<h2 *ngIf="modalData?.employee" mat-dialog-title>
	Edit: <span class="employee-name">{{ modalData.employee.firstName }} {{ modalData.employee.lastName }}
	({{ form.get('email').value }})</span>
</h2>

<!--<mat-error *ngIf="errorMessage">{{ errorMessage }}</mat-error>-->

<mat-dialog-content *ngIf="modalData.employee" [formGroup]="form">
	<div fxLayoutGap="5px" class="margin-top-10">
		<span class="vertical-middle">Change go into effect on: </span>
		<mat-form-field>
			<mat-select formControlName="effectiveStart">
				<mat-option *ngFor="let d of dates" [value]="d" (click)="chosenMonthHandler(d)">
					{{ d | date: 'MMMM  y' }}
				</mat-option>
			</mat-select>
		</mat-form-field>
	</div>

	<mat-form-field *ngIf="disabled" class="input-full-width margin-top-10">
		<input matInput placeholder="Job Title" formControlName="jobTitleName" maxlength="50"/>
	</mat-form-field>

	<mat-form-field *ngIf="disabled" class="input-full-width">
		<input matInput placeholder="Aircraft Model" formControlName="aircraftModelName" maxlength="50"/>
	</mat-form-field>

	<p>
		<span>
			<mat-checkbox name="receivesPhoneStipend" formControlName="receivesPhoneStipend">
				Phone Stipend
			</mat-checkbox>
		</span>
	</p>
	<mat-form-field class="input-full-width margin-top-10">
		<input matInput placeholder="Email Address" formControlName="email" maxlength="50"/>
		<mat-error *ngIf="form.get('email')?.hasError('invalidEmail')">
			Invalid email format
		</mat-error>
		<mat-error *ngIf="form.get('email')?.hasError('invalidDomain')">
			Email domain must be one of: {{ form.get('email')?.getError('invalidDomain')?.allowedDomains?.join(', ') }}
		</mat-error>
		<mat-error *ngIf="form.get('email')?.hasError('required')">
			Email is required
		</mat-error>
	</mat-form-field>
	<mat-form-field class="input-full-width">
		<mat-select placeholder="Upcoming Job Title" formControlName="overrideJobTitleId">
			<mat-option *ngFor="let item of jobTitles" [value]="item.jobTitleId">
				{{ item.name }}
			</mat-option>
		</mat-select>
	</mat-form-field>
	<mat-form-field class="input-full-width">
		<mat-select placeholder="Upcoming Aircraft Model" formControlName="overrideAircraftModelId">
			<mat-option *ngFor="let item of aircraftModels" [value]="item.aircraftModelId">
				{{ item.name }}
			</mat-option>
		</mat-select>
	</mat-form-field>
	<div fxLayout fxLayoutAlign="start center">
		<mat-form-field class="input-full-width">
			<mat-select placeholder="Employment Status" formControlName="employmentStatus">
				<mat-option
					*ngFor="let employmentStatus of employmentStatusOptions"
					[value]="employmentStatuses[employmentStatus]"
				>
					{{ employmentStatusTextEnum[employmentStatus] }}
					<i
						*ngIf="employmentStatuses[employmentStatus] === employmentStatuses.Active"
						class="fa fa-circle color-green-deep"
						aria-hidden="true"
					></i>
					<i
						*ngIf="employmentStatuses[employmentStatus] === employmentStatuses.LeaveOfAbsence"
						class="fa fa-circle color-orange-deep"
						aria-hidden="true"
					></i>
					<i
						*ngIf="employmentStatuses[employmentStatus] === employmentStatuses.Terminated"
						class="fa fa-circle color-red"
						aria-hidden="true"
					></i>
				</mat-option>
			</mat-select>
		</mat-form-field>
		<mat-slide-toggle
			*ngIf="form.get('employmentStatus').value !== employmentStatuses.Active"
			class="ml-1"
			formControlName="showInLists"
			color="primary"
		>Show In List
		</mat-slide-toggle
		>
	</div>
</mat-dialog-content>

<mat-dialog-actions fxLayoutAlign="end end" class="mt-5">
	<button
		*ngIf="
			modalData.employee.scheduledChanges ||
			modalData.employee.overrideJobTitleId ||
			modalData.employee.overrideAircraftModelId
		"
		class="mat-raised-button mat-warn"
		(click)="removeOverrides()"
	>
		Remove Edits
	</button>

	<button class="mat-raised-button" (click)="close()">
		Close
	</button>

	<button
		class="mat-raised-button mat-primary save-button"
		[disabled]="(!form.get('email').pristine && form.invalid) || form.pristine"
		(click)="overrideEmployee()"
	>
		Save
	</button>
</mat-dialog-actions>
